module.exports = __webpack_public_path__ + "img/bg.1c094047.png";